import { IosApple } from "@components/icons/ios-apple";
import { AndroidIcon } from "@components/icons/android-icon";
import { MobileIcon } from "@components/icons/mobile-icon";
import { MobileServis } from "@components/icons/mobile-servis";

export const MobileCardIconsEnum: any = {
  ios: IosApple,
  android: AndroidIcon,
  cross_platform: MobileIcon,
};
